const BG_OPACITY = 0.54; // Same as $overlay-opacity sass variable
const IMAGE_TOP_OFFSET = 50; // Same as $photoswipe-topbar-height sass variable

export const PhotoSwipeSharedOptions = Object.freeze({
    barsSize: {
        top: IMAGE_TOP_OFFSET,
        bottom: 'auto',
    },
    bgOpacity: BG_OPACITY,
    clickToCloseNonZoomable: false,
    hideAnimationDuration: 200,
    history: false,
    mouseUsed: true,
    preload: [1, 3],
    shareEl: false,
    showAnimationDuration: 200,
    showHideOpacity: true,
});
